module.exports = ""


//////////////////
// WEBPACK FOOTER
// D:/Projects/Hb.Bet/ServerAPI/AdminAngular/src/app/alert/alert.component.html
// module id = ../../../../../src/app/alert/alert.component.html
// module chunks = main